module.exports = __webpack_public_path__ + "static/media/winterbilanz.41f01492.mp4";